import { GetStaticProps } from "next";
import Link from "next/link";
import { AboutUsText } from "../components/content-types/omnibus/AboutUsText";

import getAboutUsEntries from '../lib/getAboutUsEntries';
import Head from "next/head";

export const getStaticProps: GetStaticProps = async (context) => {

  const aboutUsEntries = getAboutUsEntries()
  const entries = aboutUsEntries.entries

  return {
    props: {
      entries
    }
  }
}
function AboutUs({ entries }: any) {
  return (
    <>
    <Head>
          <title>Horus Heresy Omnibus Project - About Us</title>
          <meta name="description" content="A Fan-Created Guide for Navigating the Epic Series" />
          <link rel="icon" href="/favicon.ico" />
        </Head>
    
    <main>
      <div className='flex flex-col'>
        {entries.map((entry: any, index: any) => {
          return (
            <div className='p-4 ml-auto mr-auto flex flex-col' key={'overview-article-' + index}>
              <h1 className='text-3xl max-w-[42ch]'>{entry.title}</h1>
              <div className=''>
                {entry.content && <AboutUsText text={entry.content} />}
              </div>
            </div>
          )
        })}
      </div>
    </main>
    </>
  );
}
export default AboutUs;